const round = (val, type) => (type === 'updown' ? Math.round(val) : type === 'upper' ? Math.ceil(val) : val);

export default round;
